/*
 * Public API Surface of text-box-components-lib
 */

export * from './lib/text-box-components-lib.service';
export * from './lib/text-box-components-lib.component';
export * from './lib/text-box-components-lib.module';
